/**
 * Live Page - Uses unified content page
 */
import React from "react";
import { ContentPage } from "../../components/content";

const LivePage = () => {
  return <ContentPage />;
};

export default LivePage;
